import axios from "axios";
import { notificationHandler } from "reducers/notificationSlice";
import { URL } from "./MainAPILink";
import CatchMessage from "./catchMessage";

export const AddReceiptAPI = async (data, access_token) => {
  try {
    const response = await axios.post(URL + "receipts/sendReceipt", data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (err) {
    CatchMessage(err);
    return err.response.data;
  }
};
